import { render, staticRenderFns } from "./reportHuaningList.vue?vue&type=template&id=013a2b84&scoped=true"
import script from "./reportHuaningList.vue?vue&type=script&lang=js"
export * from "./reportHuaningList.vue?vue&type=script&lang=js"
import style0 from "./reportHuaningList.vue?vue&type=style&index=0&id=013a2b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013a2b84",
  null
  
)

export default component.exports